"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("../@assets/scss/components/_modalSupportContent.scss");
var ModalSupportContent = function ModalSupportContent(_ref) {
  var closeModal = _ref.closeModal;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "large-modal-overlay",
    onClick: closeModal
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "large-modal-content",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "close-modal-button",
    onClick: closeModal
  }, "X"), /*#__PURE__*/_react["default"].createElement("iframe", {
    src: "https://taugor.notion.site/ebd/1b4cd09af9de80fd818fcc3660e98f2d?v=1b4cd09af9de81e18ca0000c82985ea5",
    width: "100%",
    height: "100%",
    frameBorder: "0",
    allowFullScreen: true
  }))));
};
var _default = ModalSupportContent;
exports["default"] = _default;